import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components/native';
import Colors from '../colors';
const ALIGN_ITEMS = ['flex-start', 'flex-end', 'center', 'stretch', 'baseline'];
const ALIGN_CONTENT = ['flex-start', 'flex-end', 'center', 'stretch', 'space-between', 'space-around'];
const JUSTIFY_CONTENT = ['flex-start', 'flex-end', 'center', 'space-between', 'space-around'];
const StyledOverlay = styled.View`
  background-color: ${Colors.gray600};
  width: 100%;
  height: 100%;
  position: fixed;
  opacity: 0.4; 
  z-index: 1;
`;
const StyledContainer = styled.View`
  align-items: ${props => props.alignItems};
  align-content: ${props => props.alignContent};
  justify-content: ${props => props.justifyContent};
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: 2;
`;
export default function Overlay(props) {
  const alignItems = ALIGN_ITEMS.includes(props.alignItems) ? props.alignItems : Overlay.defaultProps.alignItems;
  const alignContent = ALIGN_CONTENT.includes(props.alignContent) ? props.alignContent : Overlay.defaultProps.alignContent;
  const justifyContent = JUSTIFY_CONTENT.includes(props.justifyContent) ? props.justifyContent : Overlay.defaultProps.justifyContent;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StyledOverlay, null), /*#__PURE__*/React.createElement(StyledContainer, {
    alignItems: alignItems,
    alignContent: alignContent,
    justifyContent: justifyContent,
    style: props.style
  }, props.children));
}
Overlay.defaultProps = {
  alignItems: 'center',
  alignContent: 'center',
  justifyContent: 'flex-start',
  style: null,
  children: ''
};
Overlay.propTypes = {
  alignItems: PropTypes.oneOf(ALIGN_ITEMS),
  alignContent: PropTypes.oneOf(ALIGN_CONTENT),
  justifyContent: PropTypes.oneOf(JUSTIFY_CONTENT),
  style: PropTypes.object,
  children: PropTypes.node
};
//# sourceMappingURL=index.js.map